import { notifyMonitoring } from '../monitoring';
import {
  CROP_ID_FOR_UNASSIGNED_STEMS,
  UNKNOWN_CROP_NAME,
} from '../../constants/fields';

export const patternIdForRow = (override, { primaryInRowPattern }) =>
  override?.inRowPatternId ||
  (!override?.cropName && primaryInRowPattern?.id) ||
  null;

// Row override pattern or no override and primary pattern
export const rowHasPattern = (override, section) =>
  !!patternIdForRow(override, section);

export const cropNameForRow = (override, { crop, primaryInRowPattern }) =>
  rowHasPattern(override, { primaryInRowPattern })
    ? undefined
    : override?.cropName || crop?.name;

export const patternNameForRow = (override, section, { inRowPatternsMap }) =>
  rowHasPattern(override, section)
    ? inRowPatternsMap[patternIdForRow(override, section)]?.name
    : undefined;

export const cropVarietyIdForRow = (
  override,
  { primaryCropVariety },
  cropVarietyIdToCropId,
  cropId,
) => {
  // Default to primaryCropVariety if override does not have a cropVarietyId
  const cropVarietyId = override?.cropVarietyId || primaryCropVariety?.id;
  // Confirm crop variety exists and belongs to the crop for this row; otherwise return null
  return cropVarietyId && cropVarietyIdToCropId[cropVarietyId] === cropId
    ? cropVarietyId
    : null;
};

export const getCropAndSpacingAtIdx = (
  override,
  { primaryInRowPattern, inRowSpacing, crop },
  cropPointIdx,
  { cropMap, cropNameToId, inRowPatternsMap },
) => {
  if (!rowHasPattern(override, { primaryInRowPattern })) {
    const cropName = override?.cropName || crop?.name;
    return {
      cropId: cropNameToId[cropName],
      cropName,
      spacing: override?.inRowSpacing || inRowSpacing,
    };
  }
  const rowPatternId = override?.inRowPatternId || primaryInRowPattern.id;
  const rowCropSequence = inRowPatternsMap[rowPatternId]?.cropSequence;
  if (!rowCropSequence) {
    notifyMonitoring(
      `No crop sequence found for row pattern id ${rowPatternId}: ${JSON.stringify(
        inRowPatternsMap,
      )}`,
    );
  }
  const sequenceIdx = cropPointIdx % (rowCropSequence?.length || 0);
  const sequenceItem = rowCropSequence?.[sequenceIdx];
  const sequenceItemCrop = cropMap[sequenceItem?.crop?.id];

  return {
    spacing: sequenceItem?.spacingFt || 10 /* Fallback value */,
    cropId: sequenceItem?.crop?.id || CROP_ID_FOR_UNASSIGNED_STEMS,
    cropName: sequenceItemCrop?.name || UNKNOWN_CROP_NAME,
  };
};

// Returns true when the conditions are met for the row override to be removed.
// Note: you may need to update this function when adding new properties
// to row overrides.
export const overrideMatchesSection = (override, section) => {
  if (!override) return true;
  if (
    (section.primaryInRowPattern?.id === override.patternId ||
      override.patternId == null) &&
    (section.crop?.id === override.cropId || override.cropId == null) &&
    (section.primaryCropVariety?.id === override.cropVarietyId ||
      override.cropVarietyId == null) &&
    (section.inRowSpacing === override.inRowSpacing ||
      override.inRowSpacing == null) &&
    (section.crop?.name === override.cropName || override?.cropName == null)
  ) {
    return true;
  }

  return false;
};
